<template>
  <div class="exam">
  	<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item>{{ groupName }}的面试邀请</el-breadcrumb-item>
		</el-breadcrumb>
  	<el-button class="button" type="primary" @click="dialogVisible = true">新增面试邀请</el-button>
  	<div class="el-row">
  		<div class="el-col el-col-4" v-for="(item, key) in list">
        <router-link :to="{name: 'interviewTjk', params: {id: item.interviewInviteId, groupName: groupName, groupId: groupId}}">
    			<div class="el-card is-always-shadow">
  					<div class="el-card__body">
  						<div class="tab-box">
                <template v-if="item.endStatus == 'Ongoing'">
                  <span class="badge active">进行中</span>
                </template>
  							<template v-if="item.endStatus == 'End'">
                  <span class="badge">已结束</span>
                </template>
  							<p class="title">{{ item.title }}</p>
  							<p>
  								<span class="padding-r-sm">申请人数：{{ item.applyNum }}</span>
  								<span>通过人数：{{ item.passedNum }}</span>
  							</p>
  							<p>截止日期：{{ item.expireTime }}</p>
  							<span class="detail">查看详情</span>
  						</div>
  					</div>
  				</div>
        </router-link>
			</div>
		</div>
		<pagination v-if="list.length > pageSize" :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
    <!--新增面试邀请-->
    <el-dialog title="新增面试邀请" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="add" ref="add" :rules="rules" label-width="120px">
        <el-form-item label="面试主题" prop="title">
          <el-input v-model="add.title" placeholder="请控制在10个字内" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="面试邀请简述" prop="description">
          <el-input type="textarea" autosize v-model="add.description" placeholder="请控制在200个字内" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="截止日期" prop="expireTime">
          <el-date-picker v-model="add.expireTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" @change='changeHandlerStart'></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addNew">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
    	dialogVisible: false,
      pageNum: 1,
      pageSize: 24,
      pages: 1,
      groupId: this.$route.query.groupId, //gg80233497726
      groupName: this.$route.query.groupName, 
      list: [],
      add: {
      	title: '',
      	description: '',
      	expireTime: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入面试主题', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入面试邀请简述', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        expireTime: [
          { required: true, message: '请选择截止日期', trigger: 'change' }
        ]
      }
    }
  },
  mounted: function() {
    this.getList(1)
  },
  methods: {
  	getList(num) {
      var data = {
        'groupId': this.groupId,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/interview/query', data).then(response => {
        var result = response.data
        if(result.success) {
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.list = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //弹出层关闭-新增
    handleClose() {
      this.$refs['add'].resetFields()
      this.dialogVisible = false
    },
    //新建面试邀请
    addNew() {
      var self = this
      this.$refs.add.validate((valid) => {
        if(valid) {
        	self.add.groupId = self.groupId
          self.$http.post(API_ROOT.college + '/interview/add', self.add).then(response => {
            var result = response.data
            if(result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              })
              self.handleClose()
              self.getList(1)
            }else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }else {
          return false
        }
      })
    },
    //时间
    changeHandlerStart(val) {
      this.add.expireTime = val
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
	margin-left: -10px;
	margin-right: -10px;
	.el-col {
		padding-left: 10px;
		padding-right: 10px;
    margin-bottom: 20px;
		.el-card {
			cursor: pointer;
		}
	}
}
.button {
	margin: 20px 0;
}
.tab-box {
	line-height: 30px;
	position: relative;
	margin: -10px -10px 10px -10px;
	.badge {
		position: absolute;
		background-color: #999999;
		display: inline-block;
		height: 24px;
		padding: 1px 8px;
		border-radius: 12px;
		color: #ffffff;
		top: 0;
    right: 0;
    line-height: 24px;
    &.active {
    	background-color: #f56c6c;
    }
	}
	.title {
		font-size: 16px;
	  font-weight: 600;
	}
	.padding-r-sm {
		padding-right: 20px;
	}
  .detail {
    position: absolute;
    bottom: -25px;
    right: 0;
    color: #409EFF;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/page/college/interview.vue